export type Conversation = {
  ClientID: string;
  ConversationID: string | null;
  ModelType: modelNames;
  Content: MessageProps[];
  Summary: string;
  Filters: DocumentsFilters;
  SelectedDocuments: string[] | null;
  TimeStamp: string;
  agent_mode: boolean | null;
};

export type MessageProps = {
  documentsSelected: any[];
  id?: string;
  sender?: string;
  text?: string;
  conversationId?: string | null;
  error?: string | undefined;
  loading?: boolean;
  desktop?: boolean;
  gptMode?: boolean;
  references?: { [key: string]: string } | null;
  filters?: DocumentsFilters;
  selectedDocuments?: string[] | null;
  initialItem?: boolean;
};



export type DocumentsFilters = {
  case_laws: {
    laws: string[];
    sections: string[];
    keywords: string[];
  };
  tax_guidances: {
    tax_guidances: string[];
    tax_categories: string[];
    keywords: string[];
  };
  client_work: {
    document_classes: string[];
    related_laws: string[];
    keywords: string[];
  };
  law_section_mapping?: {};
};

export type FeedbackInputs = {
  rating: number;
  feedback: string;
};

export type FeedbackDetails = {
  response: string;
  email: string;
  model: modelNames;
  conversationId: number;
  token: string;
};

export enum modelNames {
  baseModelName = "GPT",
  documentModelName = "With docs",
}

export enum views {
  history = "History",
  chat = "Chat",
}
